import React from "react";
import styles from "../../../styles/pages/about/ServicesGrid.module.scss";
import { Compass, Layout, Server, FlaskConical, Zap, UsersRound, ArrowRight } from "lucide-react";

const defaultItems = [
  {
    key: "product-engineer",
    title: "Product Engineer",
    blurb: "Managing the full SDLC end-to-end, developed MVPs, and handled deployments.",
    highlights: ["discovery", "product-dev", "roadmaps"],
    // href: "/services#strategy",
    icon: Compass,
    gradient: "linear-gradient(135deg, #60a5fa, #22d3ee)",
  },
  {
    key: "project-management",
    title: "Project Management",
    blurb: "overseen day-to-day product development, manage dependencies/risks, and run status cadence.",
    highlights: ["project Planning", "stakeholder management", "risk management"],
    // href: "/services#ux",
    icon: Layout,
    gradient: "linear-gradient(135deg, #8b5cf6, #60a5fa)",
  },
  {
    key: "fullstack",
    title: "Full‑Stack Developer",
    blurb: "Developing web features across frontend, backend, and APIs.",
    highlights: ["web apps", "APIs", "integrations"],
    // href: "/services#build",
    icon: Server,
    gradient: "linear-gradient(135deg, #22d3ee, #10b981)",
  },
  {
    key: "data-analysis",
    title: "Data Analysis/Research",
    blurb: "Analyzing datasets and Researches to support product and business intelligence decisions.",
    highlights: ["data management", "business Intelligence", "quantitative research"],
    // href: "/services#prototypes",
    icon: FlaskConical,
    gradient: "linear-gradient(135deg, #f59e0b, #f43f5e)",
  },
  {
    key: "venture-partnerships",
    title: "Venture Partnerships",
    blurb: "I’m open to collaborating on early-stage ventures on product strategy, and go-to-market support..",
    highlights: ["partnership", "startup", "mvp"],
    // href: "/services#automation",
    icon: Zap,
    gradient: "linear-gradient(135deg, #22d3ee, #6366f1)",
  },
  {
    key: "public-speaking",
    title: "Public Speaking",
    blurb: "Delivering talks and workshops on technical topics and business pitches.",
    highlights: ["presentation", "workshops", "facilitation"],
    // href: "/services#advisory",
    icon: UsersRound,
    gradient: "linear-gradient(135deg, #86efac, #22d3ee)",
  },
];

export default function ServicesGrid({ items = defaultItems, className = "" }) {
  return (
    <div className={`${styles.root} ${className}`}>
      {items.map((item) => (
        <ServiceCard key={item.key} item={item} />)
      )}
    </div>
  );
}

function ServiceCard({ item }) {
  const Icon = item.icon || Compass;

  const onKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      window.location.href = item.href;
    }
  };

  return (
    <a href={item.href} className={styles.card} onKeyDown={onKey} tabIndex={0}>
      <span className={styles.glow} aria-hidden />

      <div className={styles.iconWrap} style={{ backgroundImage: item.gradient }}>
        <Icon className={styles.icon} />
      </div>

      <div className={styles.texts}>
        <h3 className={styles.title}>{item.title}</h3>
        <p className={styles.blurb}>{item.blurb}</p>

        <div className={styles.chips} aria-hidden>
          {(item.highlights || []).slice(0, 3).map((h, i) => (
            <span key={i} className={styles.chip}>{h}</span>
          ))}
        </div>

        {/* Reveals on hover/focus for more detail without clutter */}
        {item.details && (
          <ul className={styles.details}>
            {item.details.slice(0, 3).map((d, i) => (
              <li key={i}>{d}</li>
            ))}
          </ul>
        )}
      </div>

      <div className={styles.cta}>
        {/* <span>Explore</span> */}
        <ArrowRight className={styles.ctaIcon} />
      </div>
    </a>
  );
}

/* =============================
   FILE: ServicesGrid.module.scss
============================= */
